
export default {
    messages: '',
    message: '/mensaje',
    delete: '/eliminar',
    
     };
  